import { usersClient } from "serviceClient";

const getAllusers = (params?: Record<string, any>) => {
  return usersClient.get<any>(`/users`, { params });
};

export { getAllusers };
